import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import ArticleDetail from "../views/ArticleDetail.vue";
import AtlasDetail from "@/views/AtlasDetail";
import PublishDetail from "@/views/PublishDetail";
import LiveDetail from "@/views/LiveDetail";
import CourseDetail from "@/views/CourseDetail";
import VideoDetail from "@/views/VideoDetail";
import TopicDetail from "@/views/TopicDetail";
import TopicTagDetail from "@/views/TopicTagDetail";
import TvList from "@/views/TvList";
import TvDetail from "@/views/TvDetail";
import AccountDetail from '@/views/AccountDetail'


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/articleDetail",
    name: "articleDetail",
    component: ArticleDetail,
  },
  {
    path: "/atlasDetail",
    name: "atlasDetail",
    component: AtlasDetail,
  },
  {
    path: "/publishDetail",
    name: "publishDetail",
    component: PublishDetail,
  },
  {
    path: "/liveDetail",
    name: "liveDetail",
    component: LiveDetail,
  },
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: CourseDetail,
  },
  {
    path: "/videoDetail",
    name: "videoDetail",
    component: VideoDetail,
  },
  {
    path: "/topicDetail",
    name: "topicDetail",
    component: TopicDetail,
  },
  {
    path: "/topicTagDetail",
    name: "topicTagDetail",
    component: TopicTagDetail,
  },
  {
    path: "/tvList",
    name: "tvList",
    component: TvList,
  },
  {
    path: "/tvDetail",
    name: "tvDetail",
    component: TvDetail,
  },
  {
    path: "/accountDetail",
    name: "accountDetail",
    component: AccountDetail,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
